import React from 'react';
import ReactDOM from 'react-dom';
import {
  AdapterDateFns,
  LocalizationProvider,
  MuiLicenseInfo,
  NoSsr,
} from '@bymason-private/legacy-pattern-components';
import { ToastProvider } from '@bymason-private/controller-shared-widgets';
import { ErrorBoundary, initBrowserLogger } from '@bymason-private/instrumentation';
import config from '@bymason/runtime-config';
import AuthProvider from '@bymason-private/auth-provider';
import { RouteProvider } from '@bymason-private/route-provider';
import { ControllerThemeProvider } from '@bymason-private/controller-v1-theme-provider';
import Router, { loginCallbackUrl, loginUrl } from './router';
import reportWebVitals from './reportWebVitals';
import { GlobalStateProvider } from './global-state/provider';

// initialize browser logger so errors are automatically logged to cloud (e.g. to DataDog)
initBrowserLogger('controller_v1', config.EnvironmentName);

// set license key for paid-for MUI components (X-Grid, etc.)
MuiLicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY || '');

window.sprigLoader(config.SprigAppId);
window.heap.load(config.HeapAppId);

ReactDOM.render(
  <React.StrictMode>
    <NoSsr>
      <ErrorBoundary>
        <AuthProvider
          appName='Controller'
          loginCallbackUrl={loginCallbackUrl}
          returnUrlAfterLogout={loginUrl}
        >
          <RouteProvider>
            <GlobalStateProvider>
              <ControllerThemeProvider>
                <ToastProvider>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Router />
                  </LocalizationProvider>
                </ToastProvider>
              </ControllerThemeProvider>
            </GlobalStateProvider>
          </RouteProvider>
        </AuthProvider>
      </ErrorBoundary>
    </NoSsr>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(/* process.env.NODE_ENV === 'development' ? console.log : undefined */);
